import { makeImmutable } from "../core";
import { ModifierSettings, Quantity } from "../ordering";
import { RArray, RMap } from "../collections";
export class ModifierSettingsParser {
    constructor(params) {
        this.parametrizationParser = params.parametrizationParser;
        makeImmutable(this);
    }
    parse(modifierItemTypeIds, settings) {
        return new ModifierSettings({
            editable: this.parametrizationParser.parse(settings.editable),
            freeItems: Quantity.fromNumber(settings.freeItems),
            defaultItems: settings.defaultItems
                ? RMap.fromIterable(new RArray(settings.defaultItems).mapOptional(([itemId, quantity]) => {
                    const itemTypeId = modifierItemTypeIds.rawFind(itemId);
                    if (itemTypeId === null) {
                        return null;
                    }
                    return [itemTypeId, Quantity.fromNumber(quantity)];
                }))
                : null,
            displayDefaultItems: settings.displayDefaultItems,
        });
    }
}
